import urlHelper from '../helpers/url';
import { model } from '../core/model';
import yaTiene from '../controllers/yaTiene';
import Analitycs from '../helpers/analytics';
import { Config } from '../core/config';
import primerAcceso from "../controllers/primerAcceso";
import pdfSuscriptoSinPDF from "../controllers/pdfSuscriptoSinPDF";
import { wallConBonificado } from '../services/wallService';

export const defaultCase = (code, isPdf) => {
    isPdf
        ? window.mostrar_error({ error: `flowHandler.flowPDF | Error inesperado ${code}` })
        : urlHelper.redirect(Config.defaultRedirectUrl);
}

export const yaTieneSuscripcionDigital = (isPdf) => {
    if (isPdf && !model.Usuario.hasPDF()) {
        console.log("Cambiar el mensaje del wall de PDF - pdfSuscriptoSinAcceso")
        pdfSuscriptoSinPDF();
    }
    else {
        console.log('Controller.yaTenia() .Redirect a CallBack');
        yaTiene();
    }
}

export const suscripcionConBonificado = () => {
    if (!wallConBonificado()) 
        return yaTiene();

    console.log('View.primerAcceso() - Redirect a Bonificado');
    primerAcceso();
}

export const flowDefault = () => {
    Analitycs.paginaVirtual(model.Window);
}

export const isWallExcluyente = () =>{
    const walls = ["V_3","V_4","V_5", "V_6", "F_3", "P"];
    return !walls.includes(Config.idWall);
}


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/helpers/flow.js